import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import FilterBar from './FilterBar';
import { BarStackedProps } from './interfaces';

const BarStacked: React.FC<BarStackedProps> = ({
  temps,
  graphData,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  selectedTemps,
  setSelectedTemps,
  handleSubmit,
  show,
  setTemplate_id,
  resetFilters,
}) => {
  const data = graphData
    ? Object.keys(graphData)?.map((key) => ({
        name: key,
        templates: graphData[key],
      }))
    : '';

  const formatYAxis = (tickItem: number) => {
    return Math.round(tickItem).toString();
  };
  let maxCount = 0;
  if (Array.isArray(data)) {
    maxCount = Math.max(...data.map((item: any) => item.templates));
  }
  const ticks = Array.from({ length: maxCount + 1 }, (_, i) => i);

  return (
    <div className="graph__wrapper">
      <FilterBar
        startDate={startDate}
        endDate={endDate}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        selectedTemps={selectedTemps}
        setSelectedTemps={setSelectedTemps}
        temps={temps}
        handleSubmit={handleSubmit}
        setTemplate_id={setTemplate_id}
        resetFilters={resetFilters}
      />
      {show && data ? (
        <ResponsiveContainer width="90%" height={500}>
          <BarChart
            data={data}
            margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
            barSize={50}
          >
            <XAxis dataKey="name" scale="point" padding={{ left: 40, right: 10 }} />
            <YAxis
              tickFormatter={formatYAxis}
              ticks={ticks} 
            />
            <Tooltip />
            <Legend />
            <CartesianGrid strokeDasharray="3 3" />
            <Bar
              dataKey="templates"
              fill="#B69A43"
              background={{ fill: '#b6994317' }}
            />
          </BarChart>
        </ResponsiveContainer>
      ) : (
        ''
      )}
    </div>
  );
};

export default BarStacked;
